import React from 'react';
import ReactDOM from 'react-dom';
import Regwall from 'components/Regwall';

// import 'styles/index.scss';

const { registrationTitle, registrationText, defaultForm } = window.Regwall;

ReactDOM.render(
  <React.StrictMode>
    <Regwall
      registrationTitle={registrationTitle}
      registrationText={registrationText}
      defaultForm={defaultForm !== '' && defaultForm !== '{{default-form}}' ? parseInt(defaultForm, 10) : 1}
    />
  </React.StrictMode>,
  document.getElementById('regwall')
);
